import { render } from "./pillConfirm.vue?vue&type=template&id=bf3b11f8&scoped=true"
import script from "./pillConfirm.vue?vue&type=script&lang=js"
export * from "./pillConfirm.vue?vue&type=script&lang=js"

import "./pillConfirm.vue?vue&type=style&index=0&id=bf3b11f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3b11f8"]])

export default __exports__